module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_about01-38e6988e6ac0857c6e1a868f4ab85809.png";